import React, { ReactNode, useContext, useMemo, useState } from 'react';

interface InstitutionMenuProviderProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  handleMenu: (isOpen: boolean) => void;
}

const defaultValue: InstitutionMenuProviderProps = {
  isMenuOpen: false,
  toggleMenu: () => undefined,
  handleMenu: () => undefined,
};

const InstitutionMenuContext = React.createContext<InstitutionMenuProviderProps>(defaultValue);

function InstitutionMenuContextProvider({ children }: { children: ReactNode }) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenu = (isOpen: boolean) => {
    setIsMenuOpen(isOpen);
  };

  const memoizedValue: InstitutionMenuProviderProps = useMemo(
    () => ({
      isMenuOpen,
      toggleMenu,
      handleMenu,
    }),
    [isMenuOpen],
  );

  return <InstitutionMenuContext.Provider value={memoizedValue}>{children}</InstitutionMenuContext.Provider>;
}

export default InstitutionMenuContextProvider;
export const useInstitutionMenuContextProvider = (): InstitutionMenuProviderProps => useContext(InstitutionMenuContext);
